import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import { isLayerSwitcherGroupState } from '@tmapy/config';
import { actionSetLayerVisibility } from '@tmapy/mapcore';
import { IndeterminedTick } from '@tmapy/style-guide';
import { actionMakeLayersVisible, actionSaveGroupVisibility } from '../actions';
function getLayersFromGroup(group) {
    return group.reduce((acc, item) => {
        if (isLayerSwitcherGroupState(item)) {
            return acc.concat(getLayersFromGroup(item.children));
        }
        acc.push(item);
        return acc;
    }, []);
}
export const GroupCheckbox = ({ layerSwitcher, layers, savedGroupVisibility, isExclusive, dispatch, }) => {
    const groupLayers = getLayersFromGroup(layerSwitcher);
    let state = null;
    for (const { layerId } of groupLayers) {
        const layer = layers.find((layer) => layer.id === layerId);
        if (layer) {
            const currentLayerVisible = layer.layerOptions.visible;
            if ((state === true && !currentLayerVisible) || (state === false && currentLayerVisible)) {
                state = null;
                break;
            }
            else {
                state = currentLayerVisible;
            }
        }
    }
    /**
     * null -> (true) -> false -> null
     */
    const handleClick = useCallback((ev) => {
        ev.stopPropagation();
        const layerIds = groupLayers.map((layer) => layer.layerId);
        if (state === null) {
            const currentRemember = {};
            for (const { layerId } of groupLayers) {
                const layer = layers.find((layer) => layer.id === layerId);
                if (layer) {
                    const currentLayerVisible = layer.layerOptions.visible;
                    currentRemember[layerId] = currentLayerVisible;
                }
            }
            dispatch(actionSaveGroupVisibility(currentRemember));
        }
        if (state === null || state === true) {
            const isExclusive = groupLayers.some((layer) => layer.exclusiveLayerIds?.some((exclusiveLayerId) => layerIds.includes(exclusiveLayerId)));
            if (state === null && !isExclusive) {
                // zaskrtnout vse (true)
                dispatch(actionMakeLayersVisible(layerIds));
            }
            else {
                // odskrtnout vse (false)
                dispatch(actionSetLayerVisibility(layerIds.reduce((acc, layerId) => {
                    acc[layerId] = false;
                    return acc;
                }, {})));
            }
        }
        else {
            // posledni zapamatovane a pokud neni ani jedna vrstva skupiny ulozena tak true
            let visibleLayerIds = layerIds.reduce((acc, layerId) => {
                const visibility = savedGroupVisibility[layerId];
                if (visibility) {
                    acc.push(layerId);
                }
                return acc;
            }, []);
            if (visibleLayerIds.length === 0) {
                visibleLayerIds = layerIds;
            }
            dispatch(actionMakeLayersVisible(visibleLayerIds));
        }
    }, [state, savedGroupVisibility, layers, groupLayers, dispatch]);
    return _jsx(IndeterminedTick, { isChecked: state, isExclusive: isExclusive, onChange: handleClick });
};
//# sourceMappingURL=GroupCheckbox.js.map